// @ts-nocheck
import { getOrderTransactionTypes } from "@store/Framework/Services/TransactionTypeService";
import { OrderTransactionType } from "@store/Framework/Types/ApiModels";
import { useEffect, useState } from "react";

export const useOrderTransactionTypes = () => {
    const [transactionTypes, setTransactionTypes] = useState<OrderTransactionType[]>([]);
    const [loadingTransactionTypes, setLoadingTransactionTypes] = useState<boolean>(true);
    const [transactionTypesError, setTransactionTypesError] = useState<string | null>(null);

    useEffect(() => {
        const fetchTransactionTypes = async () => {
            try {
                const data = await getOrderTransactionTypes();
                setTransactionTypes(data.transactionTypes || data);
            } catch (error) {
                setTransactionTypesError("Failed to load transaction types");
            } finally {
                setLoadingTransactionTypes(false);
            }
        };

        fetchTransactionTypes();
    }, []);

    return { transactionTypes, loadingTransactionTypes, transactionTypesError };
};
